import services from './services.js';
import NProgress from 'nprogress';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import $http from '$http';


export default {
    mixins: [services],
    data() {
        return {
            dialogVisible: false,
            form: this.getFormData(),
            totalLendMoney: 0
        }
    },
    methods: {
        getFormData() {
            return cloneDeep({
                "LendId": 0,
                "RePayMoney": '',
                "PreCollectCode": "",
                "Remark": ""
            });
        },
        dialogClose() {
            this.dialogVisible = false;
        },
        show(options) {
            console.log(options)
            this.form = this.getFormData()
            this.dialogVisible = true;
            this.form.LendId = options.LendId
            this.totalLendMoney = options.TotalLendMoney
        },
        submit() {
            var flag = util.checkForm({
                ele: this,
                rules: [{
                    name: "还款金额",
                    value: this.form.RePayMoney,
                    required: true,
                }, {
                    name: "预收单号",
                    value: this.form.PreCollectCode,
                    required: true,
                }]
            });

            if (!flag) {
                return;
            }
            // 判断输入的还款金额是否大于余下欠款金额
            let num1 = this.form.RePayMoney * 1
            let num2 = this.totalLendMoney * 1
            if (num1 > num2) {
                this.$notify({
                    title: '警告',
                    message: '还款金额已超当前的余下欠款金额！',
                    type: 'warning'
                });
                return;
            }
            this.RePayMentMoneyAdd()
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/Agent/AgentLend/components/repayment/vm.js